import React from 'react';
import Slider from "react-slick";
import './_slider.scss';

import Slider01 from '../../resources/images/slider/slider01.jpg';
import Slider02 from '../../resources/images/slider/slider02.jpg';
import Slider03 from '../../resources/images/slider/slider03.jpg';
import Slider04 from '../../resources/images/slider/slider04.jpg';

const settings = {
    dots: true,
    infinite: true,

    autoplay: true,
    autoplaySpeed: 3000,
    speed: 1000,
    pauseOnHover: true,
    
    slidesToShow: 1,
    slidesToScroll: 1,
  };

export default class CustomSlider extends React.Component {
    constructor(props) {
        super(props)
        this.state = {}
    }

    render() {
        return  (
            <div className="container-custom">
                <Slider {...settings}>
                    <img src={Slider01} />
                    <img src={Slider02} />
                    <img src={Slider03} />
                    <img src={Slider04} />
                </Slider>
            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/components/slider/index.jsx